import { j as C } from "../../_virtual/jsx-runtime.js";
const e = ({
  width: L = 20,
  height: r = 20,
  viewBox: s = "0 0 20 20",
  fill: t = "currentColor",
  ...n
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: L,
    height: r,
    viewBox: s,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M18.3344 14.1666C18.3333 17.5 18.3333 17.5 15.001 17.5C11.6676 17.5 10.8344 15 10.8344 12.5C10.8344 12.1846 10.8195 11.7351 10.8121 11.2079L12.498 12.1821L12.501 12.5C12.501 14.8132 13.181 15.8333 15.001 15.8333C15.9512 15.8333 16.3431 15.8275 16.6364 15.802C16.6619 15.5088 16.6676 15.1169 16.6676 14.1666C16.6676 11.4955 16.0816 9.13954 15.138 7.58264C14.4402 6.43137 13.7944 6.04788 13.4447 6.16443C13.2009 6.2457 12.9405 6.70556 12.7522 7.51691L11.2603 6.65565C11.5683 5.65868 12.0787 4.86293 12.9177 4.58329C15.4172 3.75011 18.3363 7.91663 18.3344 14.1666ZM7.08329 4.58329C7.92217 4.86292 8.43263 5.6586 8.74063 6.6555L7.24873 7.51691C7.06053 6.70556 6.80007 6.2457 6.55624 6.16443C6.20658 6.04788 5.56073 6.43137 4.86293 7.58264C3.91931 9.13954 3.33329 11.4955 3.33329 14.1666C3.33329 15.1169 3.33911 15.5088 3.36454 15.802C3.65779 15.8275 4.04973 15.8333 4.99996 15.8333C6.81992 15.8333 7.49996 14.8132 7.49996 12.5L7.50302 12.1813L9.18879 11.2085C9.18154 11.7355 9.16663 12.1848 9.16663 12.5C9.16663 15 8.33329 17.5 4.99996 17.5C1.66663 17.5 1.66663 17.5 1.66663 14.1666C1.66663 7.91663 4.58375 3.75011 7.08329 4.58329ZM10.8333 1.66663L10.8331 7.85163L14.7468 10.1116L13.9135 11.555L9.99979 9.29579L6.0865 11.555L5.25317 10.1116L9.16646 7.85163L9.16663 1.66663H10.8333Z",
        fill: t
      }
    )
  }
);
export {
  e as default
};
